/**
 * HM-440 cluster 23 Manutenzione Guasti — client API.
 *
 * Backend: apps/api-local/src/routes/maintenance.ts (HM-433..436).
 * Endpoint: POST/GET/PATCH /maintenance/issues.
 */
import { api } from './client.js';

export type IssueStatus = 'open' | 'resolved';

export type MaintenanceIssue = {
  id: string;
  tenantId: string;
  roomId: string;
  note: string;
  status: IssueStatus;
  openedAt: string;
  resolvedAt: string | null;
  createdByUserId: string | null;
  resolvedByUserId: string | null;
  updatedAt: string;
};

export type IssueListResponse = {
  items: MaintenanceIssue[];
  total: number;
  limit: number;
  offset: number;
};

export async function listIssues(opts: {
  status?: IssueStatus;
  roomId?: string;
  limit?: number;
  offset?: number;
}): Promise<IssueListResponse> {
  const qs = new URLSearchParams();
  if (opts.status) qs.set('status', opts.status);
  if (opts.roomId) qs.set('roomId', opts.roomId);
  if (opts.limit) qs.set('limit', String(opts.limit));
  if (opts.offset) qs.set('offset', String(opts.offset));
  return api(`/maintenance/issues${qs.size > 0 ? `?${qs.toString()}` : ''}`);
}

export async function getIssue(id: string): Promise<{ issue: MaintenanceIssue }> {
  return api(`/maintenance/issues/${id}`);
}

export async function createIssue(input: {
  roomId: string;
  note: string;
}): Promise<{ issue: MaintenanceIssue }> {
  return api('/maintenance/issues', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export async function updateIssueNote(
  id: string,
  note: string,
): Promise<{ issue: MaintenanceIssue }> {
  return api(`/maintenance/issues/${id}`, {
    method: 'PATCH',
    body: JSON.stringify({ note }),
  });
}

export async function resolveIssue(id: string): Promise<{ issue: MaintenanceIssue }> {
  return api(`/maintenance/issues/${id}`, {
    method: 'PATCH',
    body: JSON.stringify({ status: 'resolved' }),
  });
}
